import React, { FC } from "react";
import styles from "./styles.module.scss";
import CheckedIcon from "./CheckedIcon";
import { KatIcon } from "@amzn/katal-react";

interface LocationItemProps {
  value: string;
  name: string;
  iconName?: KatIcon.Name;
  isSelected: boolean;
  onClick: (value: string) => void;
}

const LocationItem: FC<LocationItemProps> = ({
  value,
  name,
  iconName,
  isSelected,
  onClick,
}) => {
  return (
    <div key={name} className={styles.item} onClick={() => onClick(value)}>
      <CheckedIcon isVisible={isSelected} />
      <span className={isSelected ? styles.selected : styles.unselected}>
        {iconName && <KatIcon name={iconName} size={"small"} />}
        {name}
      </span>
    </div>
  );
};

export default LocationItem;
